module.exports = __webpack_public_path__ + "static/img/product6.bcfb350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product6.png
// module id = hYg7
// module chunks = 1